import { render, staticRenderFns } from "./ModalSelectPage.vue?vue&type=template&id=2ce5e35e&scoped=true&lang=pug&"
import script from "./ModalSelectPage.vue?vue&type=script&lang=ts&"
export * from "./ModalSelectPage.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSelectPage.vue?vue&type=style&index=0&id=2ce5e35e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5e35e",
  null
  
)

export default component.exports